import { render, staticRenderFns } from "./Uf.vue?vue&type=template&id=5f63c7b3&"
import script from "./Uf.vue?vue&type=script&lang=ts&"
export * from "./Uf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports